/**
 * Default subject pattern for custom invoice emails (matches backend send logic).
 * Placeholders are replaced when the email is sent.
 */
export function getDefaultInvoiceEmailSubjectTemplate(
  tenantLang: "es" | "en"
): string {
  return tenantLang === "en"
    ? "Invoice {series}-{number} · {companyName}"
    : "Factura {series}-{number} · {companyName}";
}

export function resolveTenantLangForInvoiceEmail(
  language: string | null | undefined
): "es" | "en" {
  const l = language?.split("-")[0]?.toLowerCase();
  return l === "en" ? "en" : "es";
}

/**
 * Display-only preview of the resolved email subject. Mirrors the backend
 * buildClientInvoiceEmailSubject substitution ({{series}} {{number}}
 * {{companyName}}) with sample series/number, falling back to the default
 * subject pattern when the template is empty.
 */
export function previewInvoiceEmailSubject(
  template: string | null | undefined,
  opts: { language: "es" | "en"; companyName: string }
): string {
  const tpl =
    template?.trim() || getDefaultInvoiceEmailSubjectTemplate(opts.language);
  // Single braces {series}; legacy double {{series}} still accepted.
  // companyName goes through a replacer FUNCTION because String.replace expands
  // $-patterns ($&, $`, $', $1) in a string replacement — a razón social like
  // "ACME $& Co" would otherwise preview as "ACME {companyName} Co". The
  // backend mirror (client-invoice-email-subject.util.ts) does the same, where
  // the same defect corrupted really-sent subject lines.
  return tpl
    .replace(/\{\{?\s*series\s*\}?\}/g, "A")
    .replace(/\{\{?\s*number\s*\}?\}/g, "1234")
    .replace(/\{\{?\s*companyName\s*\}?\}/g, () => opts.companyName);
}
